import { Howl } from 'howler';
import create from 'zustand';
import useSpeakCountStore from "../store/useSpeakCountStore";

// 使用 Zustand 創建播放列表狀態
const usePlaylistStore = create((set, get) => ({
  playlist: [],
  currentIndex: 0,
  addToPlaylist: (audioPath) => set((state) => ({
    playlist: [...state.playlist, audioPath],
  })),
  setCurrentIndex: (index) => set({ currentIndex: index }),
}));

// 創建 Howl 實例
let sound = null;
let currentItem = '';

// PlayAudio 函數
export function PlayAudio(numberString) {
  // eslint-disable-next-line no-unused-vars
  const { playlist, currentIndex, addToPlaylist, setCurrentIndex } = usePlaylistStore.getState();
  currentItem = numberString;

  // 驗證輸入
  let regExp = /[a-zA-Z]/g;
  const number = parseInt(numberString, 10);
  if (isNaN(number) || number < 1 || number > 9999 || regExp.test(numberString)) {
    console.error('Invalid input. Please provide a number between 1 and 9999.');
    return;
  }

  // 構建音頻路徑
  const audioPath = `res/audio/${number}.mp3`;

  // 將音頻添加到播放列表
  addToPlaylist(audioPath);

  const addCurrentItem = (item) => {
    useSpeakCountStore.getState().addItem(item); // 更新等待播放號碼佇列狀態
  };

  // 如果沒有正在播放的音頻，開始播放
  if (!sound || !sound.playing()) {
    playNext();
    addCurrentItem(currentItem);
  }
}

// 播放下一個音頻
function playNext() {
  const { playlist, currentIndex, setCurrentIndex } = usePlaylistStore.getState();

  if (currentIndex < playlist.length) {
    setTimeout(() => {
      if (sound) {
        sound.unload();
      }
  
      sound = new Howl({
        src: [playlist[currentIndex]],
        onend: () => {
          setCurrentIndex(currentIndex + 1);
          playNext();
        }
      });
  
      sound.play();
    }, 750);

  }
}